import React, { useState } from 'react'
import getImageUrl from '../functions/getImageUrl'
import getBackgroundStyles from '../functions/getBackgroundStyles'

const AmbientPicture = ({image, isMobile, parallax=false}) => {
    const [fallbackInUse, setFallback] = useState(false)
    const {finalImageURl, imageUrl, position} = getImageUrl(image, isMobile, false, true)

    let styles = {    
        objectPosition: position
    }

    return (
        parallax ? (
            <div className="ambient-picture">
                <div className={'parallax-wrapper'}>
                    <div style={getBackgroundStyles(image, false, isMobile)} className = {'parallax'}/>
                </div>                   
                <div  className={'black-fade-div'}/> 
                <div className={'black-background'}/>
            </div>
        ) : (
            <div className={'movie-information-wrapper '}>
                <img 
                    src={finalImageURl} 
                    style={styles}
                    className='movie-information-picture'
                    alt={'Background'} 
                    onError={({ currentTarget }) => {
                        if(fallbackInUse) {
                            currentTarget.onerror = null; 
                            currentTarget.src = '';
                        } else {
                            setFallback(true)
                            currentTarget.onerror = null; 
                            currentTarget.src = imageUrl;
                        }
                    }}
                />
                <div className={'movie-information-gradient'}/>
            </div>
        )
    )
}

export default AmbientPicture